import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
  ɵInternalFormsSharedModule,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Notification, Button, UploadCard, HelperService } from '@shared';

export interface ChargebackForm {
  merchantComment: FormControl<string>;
  proofFileUrl: FormControl<File | null>;
}

@Component({
  selector: 'app-decline-chargeback-dialog',
  imports: [
    Button,
    UploadCard,
    ɵInternalFormsSharedModule,
    ReactiveFormsModule,
  ],
  templateUrl: './decline-chargeback-dialog.html',
  styleUrl: './decline-chargeback-dialog.scss',
})
export class DeclineChargebackDialog {
  data = inject(MAT_DIALOG_DATA);
  fb = inject(FormBuilder);
  helperService = inject(HelperService);
  dialog = inject(MatDialogRef<DeclineChargebackDialog>);
  notify = inject(Notification);

  form: FormGroup<ChargebackForm> = this.fb.nonNullable.group({
    merchantComment: ['', [Validators.required]],
    proofFileUrl: this.fb.control<File | null>(null, Validators.required),
  });

  close(): void {
    this.dialog.close();
  }

  onSubmit() {
    if (this.form.invalid) {
      this.helperService.validateAllFormFields(this.form);
      return;
    }
    this.dialog.close(this.form.value);
  }

  get merchantComment() {
    return this.form.get('merchantComment') as FormControl;
  }

  get proofFileUrl() {
    return this.form.get('proofFileUrl') as FormControl;
  }

  onUploadProof(file: File[] | File | null) {
    this.proofFileUrl.patchValue(file);
    this.proofFileUrl.updateValueAndValidity();
  }
}
